<template>
  <div id="reason" >
    <div class="flex flex-wrap-reverse items-center">
        <div
          @click.prevent="redirectToNew"
          class="
            p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between
            text-lg font-medium text-base text-primary border border-solid border-primary
          "
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
          <span
            class="ml-2 text-base text-primary"
          >
            Adicionar Novo
          </span>
        </div>
    </div>

    <div class="select mb-4">
      <div class="w-full mb-4">
        <strong>Permitir fechar o chat sem selecionar uma Métrica Inteligente?</strong>
      </div>
      
      <div style="align-self: center">
        <vs-switch v-model="allowEmptyReason" @change="setSetting">
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>
    </div>

    <vs-table
      ref="transferTicketTable"
      noDataText="Nenhuma Métrica Inteligente cadastrada"
      pagination
      :max-items="itemsPerPage"
      :data="reasons"
    >
      <template slot="thead">
        <vs-th>Descrição</vs-th>
        <vs-th>Ações</vs-th>
      </template>
      
      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in reasons">
            <vs-td>
              <p>
                {{ tr.description }}
              </p>
            </vs-td>

            <vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="flex items-center">
                  <feather-icon
                    icon="EditIcon"
                    v-if="canSee('update') && tr.default === null"
                    @click.prevent="redirectToEdit(tr.id)"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  />

                  <feather-icon
                    class="ml-2"
                    icon="TrashIcon"
                    v-if="canSee('delete') && tr.default === null"
                    @click.prevent="openModalToDelete(tr)"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />
                  <feather-icon
                    class="ml-1"
                    icon="ZoomInIcon"
                    v-if="tr.default !== null"
                    @click.prevent="showPopup(tr.id)"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  />

                  <vx-tooltip
                      v-if="tr.default !== null"
                      class="mr-2"
                      position="bottom"
                      text="Métricas criadas automaticamente não serão possíveis de excluir ou editar. Lembrando que esses dados são essenciais para a métrica e geração de relatórios. Estamos comprometidos em fornecer insights precisos para o seu negócio."
                  >
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2 mt-1 mt-2"></feather-icon>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup title="Remover Métrica Inteligente" :active.sync="openDeletePopUp" @close="openDeletePopUp = false" class="sizePopup">
      <p>Deseja realmente remover a métrica ?</p>

      <div class="w-full d-flex justify-content-flex-end">
        <vs-button color="danger" @click.prevent="remove()">Remover</vs-button>
      </div>
    </vs-popup>
    <vs-popup :active.sync="previewPopup" @close="previewPopup = false" class="sizePopup" title="Visualização Métrica Inteligente">
      <div style="position: sticky; top: 0; padding-top: 15px;" v-if="id !== 2">
        <reasons-preview :use_observation="useObservation" :reason_options.sync="reasonOptionsAttributes"></reasons-preview>
      </div>
      <div style="position: sticky; top: 0; padding-top: 15px; height: 480px;" v-else>
        <reasons-preview :use_observation="useObservation" :reason_options.sync="reasonOptionsAttributes"></reasons-preview>
      </div>
    </vs-popup>

  </div>
</template>
<script>
  import FormPopup from './FormPopup'
  import ReasonsPreview from "@/components/reasons/ReasonsPreview.vue";
  import { hasPermission, formatRouteTenantPath } from '@/utils'
  import requests from '@/http/requests/reasons'
  import { reasonType } from "@/supports/reasonSupport";
  import moduleSettings from '@/store/settings/moduleSettings'
  import settingService from '@/http/requests/settings';
  import { mapActions } from 'vuex'

  export default {
    name: 'reasons-list',
    components: {
      FormPopup,
      ReasonsPreview
    },
    data() {
      return {
        reasons: [],
        itemsPerPage: 10,
        openDeletePopUp: false,
        allowEmptyReason: null,
        selected: null,
        useObservation: false,
        reasonOptionsAttributes: [],
        previewPopup: false,
        description: '',
        useObservation: false,
        requireObservation: false,
        options: [],
        id: null
      }
    },
    computed: {
      settings() {
        return this.$store.state.settings.settings
      }
    },
    created () {
      this.loadReasons();
      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }

      this.$store.dispatch("settings/fetch")
      .then(() => {
        this.loadSetting()
      })
    },
    methods: {
      loadReason () {
        this.$store.dispatch('setShowLoadingOverlay', true)
        requests.get(this.id).then((response) => {
          let reason = response.data.data.reasons[0]

          if (reason) {
            this.description = reason.description
            this.useObservation = reason.use_observation
            this.requireObservation = reason.require_observation

            let opts = reason.reason_options
            opts = JSON.stringify(opts)
            opts = opts.replaceAll('reason_option_items', 'reason_option_items_attributes')
            opts = JSON.parse(opts)

            this.reasonOptionsAttributes = opts

            let currentOptions = []
            this.reasonOptionsAttributes.forEach(() => {
              currentOptions.push(ReasonOptionForm)
            })

            this.options = currentOptions
            this.$store.dispatch('setShowLoadingOverlay', false)
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Erro!',
              text: 'A Métrica Inteligente não foi encontrada'
            })

            this.$store.dispatch('setShowLoadingOverlay', false)
            this.$router.push(formatRouteTenantPath('/crm/reasons'))
          }
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      },
      showPopup(id){
        this.id = id
        this.loadReason();
        this.previewPopup = true
      },
      ...mapActions({
        'fetchSettings': 'settings/fetch'
      }),
      canSee(action) {
        return hasPermission(`reasons-${action}`)
      },
      redirectToNew () {
        this.$router.push(formatRouteTenantPath('/crm/reasons/new'))
      },
      redirectToEdit (id) {
        this.$router.push(formatRouteTenantPath('/crm/reasons/' + id + '/edit'))
      },
      loadSetting(){
        this.allowEmptyReason = !!parseInt(this.settings.allow_close_ticket_without_reason)
      },
      loadReasons () {
        this.reasons = [];
        this.$store.dispatch('setShowLoadingOverlay', true)

        requests.fetch({deleted: false, type: reasonType}).then((response) => {
          this.id = response.data.data.reasons
          this.reasons = response.data.data.reasons;
          this.$store.dispatch('setShowLoadingOverlay', false)
          this.reasonOptionsAttributes.forEach(() => {
              currentOptions.push(ReasonOptionForm)
          })
        }).catch((error) => {
          this.$store.dispatch('setShowLoadingOverlay', false)
          console.log(error)
        })
      },
      setSetting(){
        settingService.updateKeyValue({
          key: 'allow_close_ticket_without_reason', 
          value: this.allowEmptyReason
        })
        .then(() => {
          this.fetchSettings()
        })
      },
      openModalToDelete(selected) {
        this.selected = selected;
        this.openDeletePopUp = true;
      },
      remove() {
        requests.remove(this.selected.id).then(() => {
          this.openDeletePopUp = false;
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Métrica Inteligente foi removida com sucesso'
          });
          this.loadReasons();
        }).catch((error) => {
          console.log(error)
        })
      },
    },
    beforeRouteLeave(to, from, next) {
      if (this.openDeletePopUp || this.previewPopup) {
          this.openDeletePopUp = false;
          this.previewPopup = false;
          setTimeout( ()=> {
          next();
          }, 2);
      }
      else {
          next();
      }
    }
  }
</script>
 
<style lang="scss">

#reason {
  .select {
    padding: 15px; 
    display:flex; 
    background: #fff;
    border-radius:10px; 
    text-align:center;
    flex-direction: column; 
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 0.7rem;
    padding: 0 1rem;

    tr{
      box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
      td{
        padding: 10px;
      }
    }
  }

  .vs-table--thead{
    th {
      
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text{
        text-transform: uppercase;
        font-weight: 600;
        
      }
    }
    tr{
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}


</style>
